module.exports = __webpack_public_path__ + "img/error-bg.5df682a5.jpg";